import styled from 'styled-components'

import { ProgressStyled } from '../../Progress/styles/ProgressStyled'

interface IMultiProgressBarStyledProps {
  width: number
}

export const MultiProgressBarStyled = styled.div<IMultiProgressBarStyledProps>`
  min-width: ${(props) =>
    props.width === 0 ? 0 : props.theme.typography.pxToRem(10)};
  width: ${(props) => props.width}%;

  ${ProgressStyled} {
    height: 100%;

    .MuiLinearProgress-bar {
      transform: none !important;
    }

    .root {
      height: 100%;
    }
  }

  ${(props) =>
    props.width > 0 &&
    `& + & {
        border-left: 2px solid ${props.theme.colors.white};
      }
    `}

  ${(props) => (props.width === 0 ? 'border-left: none !important;' : '')}
`
